import type { Version } from '../fetcher/fetcher';

export interface ApiErrorSummary<TErrorBody = unknown> {
  status: number;
  statusText: string;
  endpoint: string;
  version: Version;
  response: Response;
  errorBody?: TErrorBody;
}

export class ApiError<TErrorBody = unknown> extends Error {
  cause: ApiErrorSummary<TErrorBody>;

  constructor(message: string, cause: ApiErrorSummary<TErrorBody>) {
    super(message);
    this.cause = cause;

    // https://stackoverflow.com/questions/41102060/typescript-extending-error-class
    // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
